/**
 * Footer - public site footer with About / Roadmap and key links
 */
import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-white/10 bg-[#08070C] px-5 py-10" data-testid="site-footer">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-8">
          {/* Brand */}
          <div className="max-w-xs">
            <div className="flex items-center gap-3 mb-3">
              <img src="/nlt-radio-logo.png" alt="NLT Radio" className="w-11 h-11 object-contain" />
              <span className="text-white font-bold text-lg tracking-tight" style={{ fontFamily: 'Unbounded' }}>NLT Radio</span>
            </div>
            <p className="text-[#71717A] text-sm leading-relaxed">
              Real music deserves a real home. Own your story, connect with your fans, and bring back the grind.
            </p>
          </div>

          {/* Links */}
          <div className="grid grid-cols-2 gap-x-12 gap-y-2">
            <div className="flex flex-col gap-2">
              <span className="text-white/40 text-xs uppercase tracking-wider mb-1">Company</span>
              <Link to="/about" className="text-[#A1A1AA] text-sm py-1.5 block hover:text-[#00F0FF] transition-colors" data-testid="footer-about-link">About Us</Link>
              <Link to="/roadmap" className="text-[#A1A1AA] text-sm py-1.5 block hover:text-[#00F0FF] transition-colors" data-testid="footer-roadmap-link">Roadmap</Link>
              <Link to="/help" className="text-[#A1A1AA] text-sm py-1.5 block hover:text-[#00F0FF] transition-colors">Help Center</Link>
              <Link to="/terms" className="text-[#A1A1AA] text-sm py-1.5 block hover:text-[#00F0FF] transition-colors" data-testid="footer-terms-link">Terms & Acceptable Use</Link>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-white/40 text-xs uppercase tracking-wider mb-1">Explore</span>
              <Link to="/discover" className="text-[#A1A1AA] text-sm py-1.5 block hover:text-[#00F0FF] transition-colors">Discover</Link>
              <Link to="/marketplace" className="text-[#A1A1AA] text-sm py-1.5 block hover:text-[#00F0FF] transition-colors">Shop</Link>
              <Link to="/clips" className="text-[#A1A1AA] text-sm py-1.5 block hover:text-[#00F0FF] transition-colors">Clips</Link>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-[#52525B] text-xs">© {year} NLT Radio. All rights reserved.</p>
          <p className="text-[#52525B] text-xs">The artist is the label.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
